import { createContext } from 'react';
const LanguageContext = createContext(false);
const LanguageProvider = ({ location, children, pageContext, globalData }) => {
    return children;
};
export default LanguageProvider;
export const useLanguage = () => {
    return;
};
//# sourceMappingURL=language-provider.js.map